exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2yCePWk0SHyyP--1SgiUQx{margin-top:0!important}", ""]);

// exports
exports.locals = {
	"automaticCheckbox": "_2yCePWk0SHyyP--1SgiUQx"
};